import React, {Component} from "react";
import BlockDatargrid from "./block/BlockDatargrid";
import BlockForm from "./block/BlockForm";
import SpecificBlockOption from "./specific/SpecificBlockOption";
import axios from "axios";
import AuthService from "../../AuthService";
import loader from "../../img/loader.gif";

class Search extends Component {
    constructor(props) {
        super(props);

        this.state = {
            initData: this.props.initData,
            result: null,
            data: {},
            formData: {}
        }

        this.change = this.change.bind(this);
        this.changeOrder = this.changeOrder.bind(this);
        this.changePage = this.changePage.bind(this);
        this.submit = this.submit.bind(this);
    }

    componentDidMount() {
        this.loadData(false);
    }

    async loadData(submit) {
        let data = Object.assign({}, this.state.initData, this.state.formData);

        await axios.post(
            AuthService.getUrl('/datagrid'),
            data,
            AuthService.getAuthHeader()
        ).then(res => {
            this.setState({
                result: res.return,
                data: res.data.data
            });

            this.state.data.screen.blocks.map(block => {
                {block.view === '/public/jsp/core/block/blockDatagrid.jsp' &&
                    this.setState(state => {
                        const formData = state.formData;
                        formData["DATAGRID_PAGE_INDEX_" + block.id] = block.pageIndex;
                        formData["DATAGRID_PAGE_SIZE_" + block.id] = block.pageSize;
                        formData["DATAGRID_ORDER_" + block.id] = block.order;
                        formData["DATAGRID_ASCENDING_" + block.id] = block.isAscending;
                        return {formData: formData};
                    });
                }
            });
        }).catch(err => {
            this.setState({errorMessage: 'Recherche impossible'});
        });
    }

    change(e) {
        //console.log(e.target.name + " >> " + e.target.value);
        const target = e.target;
        this.setState(state => {
            const formData = state.formData;
            formData[target.name] = target.value;
            return {formData : formData};
        });
    }

    changeOrder(blockId, blockItemId, asc) {
        this.state.formData["DATAGRID_ORDER_" + blockId] = blockItemId;
        this.state.formData["DATAGRID_ASCENDING_" + blockId] = asc;
        this.loadData(true);
    }

    changePage(blockId, page) {
        console.log(blockId + " - " + page);
        this.state.formData["DATAGRID_PAGE_INDEX_" + blockId] = page;
        this.loadData(true);
    }

    submit(e) {
        e.preventDefault();
        this.loadData(true);
    }

    getComponent(block) {
        switch (block.view) {
            case '/public/jsp/core/block/blockForm.jsp' : return BlockForm;
            case '/public/jsp/core/block/blockDatagrid.jsp' : return BlockDatargrid;
            case '/public/jsp/core/specific/block/SpecificBlockOption.jsp' : return SpecificBlockOption;
        }
        return null;
    }

    render() {
        if (this.state.result === null) {
            return (
                <img src={loader} alt="loading" style={{"display": "block", "margin": "auto"}}/>
            );
        } else {
            return (
                <div className="coreScreen">
                    <form method="post"
                          encType="multipart/form-data"
                          onSubmit={e => this.submit(e)}>
                        {this.state.data.screen.blocks.map(block => {
                            const ComponentName = this.getComponent(block);
                            if (ComponentName !== null) {
                                return (
                                    <div key={block.id} className={block.class} style={JSON.parse(!(block.style) ? "{}" : block.style)}>
                                        {!!(block.title1) &&
                                        <div className="coreBlock-header">
                                            <span className="coreBlock-title1">{block.title1}</span><br/>
                                            <span className="coreBlock-title2">{block.title2}</span>
                                        </div>
                                        }

                                        <div className="coreBlock-content">
                                            <ComponentName
                                                block={block}
                                                onChange={this.change}
                                                onChangeOrder={this.changeOrder}
                                                onChangePage={this.changePage}
                                                onSubmit={this.submit}
                                                externalCall={this.props.externalCall}/>
                                        </div>
                                    </div>
                                )
                            }
                        })}
                    </form>
                </div>
            );
        }
    }
}

export default Search;